import React, { Fragment } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function HomeTestinomials() {

const testimonials = [
{
name: "Puja Singh",
role: "CEO, Manipal Fintech",
feedback:
" We were facing hygiene issues almost every single day. After Helperji's professional cleaning staff came in everything improved steadily Now our workspace feels fresh throughout the day.",
image: "/assets/img/testimonials/Manipal-Fintech.png",
},
{
name: "Sumit Aggarwal",
role: "Owner, FundVise",
feedback:
"Our office used to look messy and unorganized very often. After Helperji's cleaning experts handled everything things improved consistently Now the environment remains neat most of the time.",
image: "/assets/img/testimonials/FundVise.png",
},
{
name: "Rukhsar Memon",
role: "Founder, Finbros",
feedback:
"There were frequent complaints about dirt and poor maintenance earlier. After Helperji's skilled cleaning crew took over things improved noticeably Now the workplace remains clean throughout the day.",
image: "/assets/img/testimonials/Finbros-Ca.jpg",
},
{
name: "Vikal Singh",
role: "Owner, VDS Work Euthopia",
feedback:
"We were getting cleanliness complaints almost every week. After Helperji's commercial cleaning team started the situation improved gradually Now the office stays clean most of the day",
image: "/assets/img/testimonials/VDS.jpg",
},
{
name: "Mayur Dixit",
role: "Owner, BSI Business Park",
feedback:
"We tried multiple cleaning vendors earlier but consistency was always missing. HelperJi’s team follows a proper routine and completes every task carefully. The office now looks fresh every morning, and we no longer worry about hygiene or cleanliness issues.",
image: "/assets/img/testimonials/BSI-Logo.jpg",
},
{
name: "Vikas Sharma",
role: "Owner, Rally Infra",
feedback:
"Our office receives many client visits, so maintaining cleanliness is very important for us. After HelperJi started providing cleaning services, the workspace feels more professional and organized. Guests also notice the difference when they walk in.",
image: "/assets/img/testimonials/Rally-Infra.jpg",
},
{
name: "RAJESH KUMAR",
role: "Owner, Expedite Impex",
feedback:
"Earlier our office cleaning was irregular and employees often noticed dust on desks and floors. After HelperJi’s team started working with us, the difference became visible quickly. Now the workspace feels cleaner, organized, and much more comfortable throughout the day.",
image: "/assets/img/testimonials/expedite.jpg",
},
{
name: "VIJAY KUMAR",
role: "Owner, Tsuyo",
feedback:
"Before hiring HelperJi we had to constantly remind cleaning staff about basic tasks. Since their team took over, everything runs smoothly. The office stays neat, washrooms are properly maintained, and employees genuinely appreciate the improved workplace environment..",
image: "/assets/img/testimonials/Tsuyo.jpg",
}
];

return (
<Fragment>

<section className="py-5 bg-white">

<div className="container">

{/* Heading */}

<div className="text-center mb-5">
<h2 className="fw-bold">
What Our <span style={{ color: "#ED1C24" }}>Clients Say</span>
</h2>
<p className="text-muted">
Trusted by thousands of satisfied customers
</p>
</div>


{/* Swiper Slider */}

<Swiper

modules={[Navigation, Pagination, Autoplay]}

spaceBetween={24}

navigation

pagination={{ clickable: true }}

autoplay={{
delay: 4000,
disableOnInteraction: false,
}}

breakpoints={{

0: {
slidesPerView: 1
},

576: {
slidesPerView: 1
},

768: {
slidesPerView: 2
},

992: {
slidesPerView: 3
}

}}

>

{testimonials.map((item, index) => (

<SwiperSlide key={index}>

<div className="card bg-light h-100 shadow-sm border-0 text-center p-4">

<img
src={item.image}
alt={item.name}
className="rounded-circle mx-auto mb-3"
width="90"
height="90"
/>

<p className="text-muted fst-italic">
“{item.feedback}”
</p>

<h5 className="fw-semibold mb-0">{item.name}</h5>

<small className="text-danger">{item.role}</small>

</div>

</SwiperSlide>

))}

</Swiper>

</div>

</section>

</Fragment>
);
}

export default HomeTestinomials;